import React from 'react';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from 'src/components/design-system/buttons';
import styles from './ask-panda-chat.module.scss';
import { RenderChatMessages, RenderUserInput } from './components/';
import { useDispatch } from 'react-redux';
import { setAIChatState } from 'shared/store/actions/ai.actions';
import { useChatConversation, ChatProvider } from './hooks/use-chat-conversation';
import analyticsService from 'src/helpers/analytics.service';
import { ANALYTICS_SOURCES, colorPalette, EVENTS } from 'shared/constants';
import { Drawer } from 'antd';
import navigationContextManager from 'shared/helpers/src/navigation-context-manager';

export function AskPandaChat() {
  const analyticsTriggers = {
    onMessage: payload => analyticsService.track(EVENTS.AI_CHAT.MESSAGE, payload),
    onErrorMessage: payload => analyticsService.track(EVENTS.AI_CHAT.ERROR, payload),
    onEditMessage: payload => analyticsService.track(EVENTS.AI_CHAT.EDIT_MESSAGE, payload),
    onClear: payload => analyticsService.track(EVENTS.AI_CHAT.CLEAR_CHAT, payload),
  };

  return (
    <ChatProvider analyticsTriggers={analyticsTriggers}>
      <Chat />
    </ChatProvider>
  );
}

function Chat() {
  const dispatch = useDispatch();
  const { conversationId, lang, isOpen, isChatEnabled } = useChatConversation();

  const closeChat = () => {
    dispatch(setAIChatState(false));

    analyticsService.track(EVENTS.AI_CHAT.CLOSE);
  };

  const handleMouseEnter = () => {
    navigationContextManager.setContext({
      source: ANALYTICS_SOURCES.AI_CHAT,
      sourceId: conversationId,
    });
  };

  const handleMouseLeave = () => {
    navigationContextManager.clearContext();
  };

  if (!isChatEnabled) {
    return null;
  }

  return (
    <Drawer
      open={isOpen}
      onClose={closeChat}
      placement="right"
      mask={false}
      closable={false}
      className="new-design-system"
      styles={{
        body: { padding: 0, display: 'flex', flexDirection: 'column', height: '100%' },
        footer: { padding: 0, width: '100%' },
        wrapper: {
          width: '40%',
          top: 'var(--header-height)',
          height: 'calc(100% - var(--header-height))',
        },
      }}
      title={
        <div className={styles.header}>
          <div>
            <h2>{lang.HEADER}</h2>
            {conversationId && (
              <span className={styles.chatId}>
                {lang.CHAT_ID} {conversationId}
              </span>
            )}
          </div>
          <IconButton
            tooltipProps={{ placement: 'left' }}
            type="button"
            onClick={closeChat}
            label={lang.CLOSE_CHAT || 'Close chat'}>
            <FontAwesomeIcon icon={faXmark} color={colorPalette.primaryMain8} size="xl" />
          </IconButton>
        </div>
      }
      footer={<RenderUserInput />}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <RenderChatMessages />
      </div>
    </Drawer>
  );
}
